export default __webpack_public_path__ + "locales/nl/SharingPanel.json?hash=580e8eb22580e555b86b259cde5438e3";